import { useNavigate } from 'react-router-dom';
import { X, ArrowLeft, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function CancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-muted flex items-center justify-center px-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="py-8">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <X size={32} className="text-gray-500" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Checkout Cancelled
            </h1>
            <p className="text-gray-600 mb-6">
              Your subscription was not completed. No charges were made.
              You can try again whenever you're ready.
            </p>
            <div className="space-y-3">
              <Button
                onClick={() => navigate('/search')}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white"
              >
                <RefreshCw size={18} className="mr-2" />
                Try Again
              </Button>
              <Button
                onClick={() => navigate('/')}
                variant="outline"
                className="w-full"
              >
                <ArrowLeft size={18} className="mr-2" />
                Go to Homepage
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

